export default {"src":"/_next/static/media/0x55d398326f99059ff775485246999027b3197955.fc08aec8.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};